// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9f84b59","667":"918b3324"}[chunkId] + ".chunk.js";
};